;(function () {
  var body = document.querySelector('body');
  if (!body) return;
  var bodyData = body.dataset || {};
  var template = bodyData.template || '';

  function ampReady() {
    return !!(window.is_amplitude_enabled && window.amplitude && typeof window.amplitude.track === 'function');
  }

  // Shopify line-item / variant prices are always integer cents (e.g. 38000 -> 380.00).
  // Always divide by 100 so the same price appears across product_viewed, added_to_cart,
  // size_selected and checkout_started.
  function centsToPrice(v) {
    if (v == null || v === '') return null;
    var n = typeof v === 'number' ? v : parseFloat(v);
    if (!isFinite(n)) return null;
    return Math.round(n) / 100;
  }

  // product_collections is rendered server-side on PDP only:
  //   - body[data-product-collections]  (JSON-encoded array of collection titles)
  //   - window.__DRESSX_TRYON_PARAMS.product_collections (same array, fallback)
  // Returns an array of strings, or null when nothing is available (e.g. on cart page).
  function getProductCollections() {
    var raw = bodyData.productCollections;
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) return parsed;
      } catch (e) {}
    }
    try {
      var p = window.__DRESSX_TRYON_PARAMS;
      if (p && Array.isArray(p.product_collections) && p.product_collections.length) {
        return p.product_collections;
      }
    } catch (e) {}
    return null;
  }

  // Currency for events that include `price`. Prefer body data (rendered server-side via
  // {{ cart.currency.iso_code }}), then Shopify's runtime currency, otherwise empty.
  function getCurrency(fallback) {
    if (fallback) return fallback;
    if (bodyData.currency) return bodyData.currency;
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return '';
  }

  // try_on_completed is `true` once the user has finished a try-on in this session.
  // The try-on script (try-on_size_twin_full.js) sets the sessionStorage flag below
  // when the try-on result loads successfully.
  var TRYON_FLAG_KEY = 'dressx_try_on_completed';
  function hasCompletedTryOn() {
    try { return sessionStorage.getItem(TRYON_FLAG_KEY) === '1'; } catch (e) { return false; }
  }

  // ---------- page_view ----------
  if (ampReady()) {
    window.amplitude.track('page_view', {
      page_name: bodyData.pageName || template || 'page',
      signin: bodyData.signin === 'true'
    });
  }

  // ---------- cart_viewed ----------
  if (template === 'cart') {
    if (ampReady()) {
      window.amplitude.track('cart_viewed', {
        signin: bodyData.signin === 'true',
        try_on_completed: hasCompletedTryOn()
      });
    }
  }

  // ---------- product_viewed ----------
  if (template === 'product') {
    if (ampReady()) {
      var ds = bodyData;
      var signinValue = ds.signin === 'true';
      var price = centsToPrice(ds.productPrice);
      var referrer = typeof document.referrer === 'string' ? document.referrer : '';
      var source = 'direct';
      try {
        if (referrer) {
          var refUrl = new URL(referrer);
          if (refUrl.origin === window.location.origin) {
            var path = (refUrl.pathname || '').toLowerCase();
            if (path.indexOf('/search') !== -1) source = 'search';
            else if (path.indexOf('/cart') !== -1) source = 'cart';
            else if (path.indexOf('/collections/') !== -1) source = 'collection';
            else if (path.indexOf('wishlist') !== -1) source = 'wishlist';
            else if (path.indexOf('/account') !== -1) source = 'account';
            else if (path === '/' || path === '') source = 'home';
            else source = 'other';
          } else source = 'external';
        }
      } catch (e) {}
      var props = { signin: signinValue, try_on_completed: hasCompletedTryOn(), source: source };
      if (ds.productId) props.id = ds.productId;
      if (ds.productSku) props.sku = ds.productSku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      if (ds.productCategory) props.product_category = ds.productCategory;
      if (ds.productBrand) props.product_brand = ds.productBrand;
      var pvCollections = getProductCollections();
      if (pvCollections) props.product_collections = pvCollections;
      window.amplitude.track('product_viewed', props);
    }
  }

  // ---------- email_submitted (newsletter) ----------
  // Newsletter forms in this theme use {% form 'customer' %} with id="newsletter-form-<section.id>".
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (!form.matches('form[id^="newsletter-form-"]')) return;
      if (!ampReady()) return;
      window.amplitude.track('email_submitted', { description: 'user submitted email' });
    },
    true
  );

  // ---------- login: set sessionStorage flag whenever the user initiates a login ----------
  // Salt Murphy uses Shopify's new Customer Account API. The "login" trigger is a
  //   <a href=".../customer_authentication/redirect?...">
  // link in the header / sidebar that redirects to a Shopify-hosted login UI and
  // then back to the storefront. We also keep support for the classic flow where
  //   {% form 'customer_login' %} renders <form action=".../account/login">.
  // Either way, we set a sessionStorage flag at the moment the user starts the
  // login flow; the flag is consumed by the page-load handler below once the
  // user comes back signed-in (regardless of which template they land on).
  function markLoginInitiated() {
    try { sessionStorage.setItem('loginFormSubmitted', '1'); } catch (err) {}
  }
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      var action = String(form.action || '');
      if (action.indexOf('/account/login') === -1) return;
      markLoginInitiated();
    },
    true
  );
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var link = t.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (
        href.indexOf('customer_authentication/redirect') !== -1 ||
        href.indexOf('/account/login') !== -1
      ) {
        markLoginInitiated();
      }
    },
    true
  );

  // ---------- login (after successful sign-in) ----------
  // After the customer authentication redirect the user can land on any page
  // (account, home, the previous PDP, etc.) — not just /account. Fire the event
  // as long as (a) we previously recorded that login was initiated, and (b) the
  // server-rendered body now reports a signed-in customer.
  (function trackLoginIfReturning() {
    var isLoginReferal = null;
    try { isLoginReferal = sessionStorage.getItem('loginFormSubmitted'); } catch (err) {}
    if (!isLoginReferal) return;
    if (!ampReady()) return;
    if (bodyData.signin !== 'true') return;
    window.amplitude.track('login', { status: 'login successful' });
    try { sessionStorage.removeItem('loginFormSubmitted'); } catch (err) {}
  })();

  // ---------- added_to_cart ----------
  // <product-form> dispatches CustomEvent('variant:add', { detail: { items, cart } })
  // after a successful POST /cart/add.js. See assets/theme.js -> ProductForm.onSubmit.
  function trackAddedToCart(item, cartCurrency) {
    if (!item) return;
    if (!ampReady()) return;
    var signinValue = bodyData.signin === 'true';
    var price = centsToPrice(item.price);
    var props = { signin: signinValue };
    if (item.id != null) props.id = item.id;
    if (item.sku != null) props.sku = item.sku;
    if (price != null) {
      props.price = price;
      var curr = getCurrency(cartCurrency);
      if (curr) props.currency = curr;
    }
    if (item.product_type != null) props.product_category = item.product_type;
    if (item.vendor != null) props.product_brand = item.vendor;
    var atcCollections = getProductCollections();
    if (atcCollections) props.product_collections = atcCollections;
    window.amplitude.track('added_to_cart', props);
  }
  document.addEventListener('variant:add', function (event) {
    var detail = (event && event.detail) || {};
    var items = detail.items || [];
    var first = items[0] || detail.item || null;
    var cartCurrency = (detail.cart && detail.cart.currency) || '';
    trackAddedToCart(first, cartCurrency);
  }, true);
  // Legacy GA_ADD_TO_CART support, kept for compatibility.
  window.addEventListener('GA_ADD_TO_CART', function (event) {
    var item = (event.detail && event.detail.item) || null;
    if (!item) return;
    var lineItem = item.items && item.items[0] ? item.items[0] : item;
    var cartCurrency = (item.cart && item.cart.currency) || (event.detail && event.detail.cart && event.detail.cart.currency) || '';
    trackAddedToCart(lineItem, cartCurrency);
  });

  // ---------- checkout_started ----------
  // The checkout button <button name="checkout" type="submit"> lives inside
  // <form id="cart-main-form"> (cart page) and inside cart-drawer / cart-drawer-custom.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var submitter = e.submitter;
      var isCheckoutSubmit =
        form && form.action && form.action.indexOf('cart') !== -1 &&
        (submitter && (submitter.name === 'checkout' || submitter.getAttribute('name') === 'checkout'));
      if (!isCheckoutSubmit) return;
      if (!ampReady()) return;
      e.preventDefault();
      var checkoutUrl = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '') + '/checkout';
      var cartUrl = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js';
      fetch(cartUrl)
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = cart.items || [];
          var first = items[0];
          var price = centsToPrice(first && first.price);
          var props = { try_on_completed: hasCompletedTryOn() };
          if (first && first.id != null) props.id = first.id;
          if (first && first.sku != null) props.sku = first.sku;
          if (price != null) {
            props.price = price;
            var curr = getCurrency(cart && cart.currency);
            if (curr) props.currency = curr;
          }
          if (first && first.product_type != null) props.product_category = first.product_type;
          if (first && first.vendor != null) props.product_brand = first.vendor;
          window.amplitude.track('checkout_started', props);
          setTimeout(function () { window.location.href = checkoutUrl; }, 150);
        })
        .catch(function () { window.location.href = checkoutUrl; });
    },
    true
  );

  // ---------- search_opened ----------
  // Salt Murphy theme uses Shopify's <header-search> custom element. The trigger is
  //   <a href="/search" aria-controls="header-search-sections--<id>__header">
  // and the drawer is
  //   <header-search id="header-search-sections--<id>__header" class="header-search">
  // with an <input class="header-search__input" name="q" /> inside. We listen for
  //   - clicks on any element whose aria-controls points at a header-search-* drawer
  //     (covers header / mobile sidebar / footer / legacy "search-drawer" themes), AND
  //   - focus on the search input itself, in case the drawer is opened via keyboard
  //     shortcut or routing without going through one of the click triggers.
  // The drawer auto-focuses the input when opened, so click and focus handlers may
  // both fire back-to-back; we coalesce them with a short debounce.
  var lastSearchOpenedAt = 0;
  function querySearchInput() {
    return (
      document.querySelector('header-search input[name="q"]') ||
      document.querySelector('input.header-search__input') ||
      document.querySelector('#header-predictive-search input[name="q"]') ||
      document.getElementById('search-drawer-input') ||
      document.querySelector('input[name="q"]')
    );
  }
  function fireAmplitudeSearchOpened(triggerEl, fallbackInput) {
    if (!ampReady()) return;
    var now = Date.now();
    if (now - lastSearchOpenedAt < 800) return;
    lastSearchOpenedAt = now;
    var input = fallbackInput || querySearchInput();
    var query = (input && input.value) ? input.value.trim() : '';
    var source = 'drawer';
    if (triggerEl && triggerEl.closest) {
      var hostHeader = triggerEl.closest('header, [id*="header"], [class*="header"]');
      var hostDrawer = triggerEl.closest('[id*="drawer"], [class*="drawer"]');
      if (hostDrawer) source = 'drawer';
      else if (hostHeader) source = 'header';
    }
    window.amplitude.track('search_opened', {
      signin: bodyData.signin === 'true',
      query: query,
      source: source
    });
  }
  // Use event delegation so dynamically-rendered triggers (e.g. inside the mobile
  // sidebar drawer) are also covered.
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var trigger = target.closest(
      'a[aria-controls^="header-search-"],' +
      'button[aria-controls^="header-search-"],' +
      'a[aria-controls="search-drawer"],' +
      'button[aria-controls="search-drawer"]'
    );
    if (!trigger) return;
    fireAmplitudeSearchOpened(trigger, null);
  }, true);
  // Focus on the search input — covers cases where the drawer is opened by other
  // means (keyboard shortcut, deep link). Bound late so the input exists.
  function bindSearchInputFocus() {
    var input = querySearchInput();
    if (!input || input.__dressxSearchBound) return;
    input.__dressxSearchBound = true;
    input.addEventListener('focus', function () { fireAmplitudeSearchOpened(input, input); });
  }
  bindSearchInputFocus();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSearchInputFocus, { once: true });
  }

  // ---------- size_selected (PDP) ----------
  // variant-picker dispatches CustomEvent('variant:change', { detail: { variant, previousVariant, formId } }).
  // We only fire size_selected if the changed option is a size option (detected by <legend> text
  // of the fieldset containing input[data-option-position=N]).
  // All non-ASCII labels are written as \uXXXX escapes so the file stays robust against
  // editors / pipelines that may re-encode the source.
  if (template.indexOf('product') !== -1) {
    // size, sizes, taille, tailles, talla, tallas, tamanho, tamanhos,
    // gr\u00f6\u00dfe (groe), gr\u00f6ssen (grssen), gr\u00f6sse, gr\u00f6ssen,
    // misura, misure,
    // \u0440\u0430\u0437\u043c\u0435\u0440 (??????), \u0440\u0430\u0437\u043c\u0435\u0440\u044b (???????),
    // \u30b5\u30a4\u30ba (???),
    // \uce58\uc218 (??),
    // \u5c3a\u7801 (??), \u5c3a\u5bf8 (??)
    var SIZE_LABEL_RE = new RegExp(
      '^(' +
        'size|sizes|' +
        'taille|tailles|' +
        'talla|tallas|' +
        'tamanho|tamanhos|' +
        'gr[o\u00f6]sse|gr[o\u00f6]ssen|gr\u00f6\u00dfe|' +
        'misura|misure|' +
        '\u0440\u0430\u0437\u043c\u0435\u0440|\u0440\u0430\u0437\u043c\u0435\u0440\u044b|' +
        '\u30b5\u30a4\u30ba|' +
        '\uce58\uc218|' +
        '\u5c3a\u7801|\u5c3a\u5bf8' +
      ')(?![a-z])',
      'i'
    );

    function getChangedOptionPosition(variant, prev) {
      if (!variant) return -1;
      var keys = ['option1', 'option2', 'option3'];
      for (var i = 0; i < keys.length; i++) {
        var nv = variant[keys[i]] || '';
        var pv = (prev && prev[keys[i]]) || '';
        if (nv && nv !== pv) return i + 1;
      }
      return -1;
    }

    function getLegendForOptionPosition(formId, position) {
      var input = null;
      if (formId) {
        input = document.querySelector('input[form="' + formId + '"][data-option-position="' + position + '"]');
      }
      if (!input) {
        input = document.querySelector('input[data-option-position="' + position + '"]');
      }
      if (!input) return '';
      var fieldset = input.closest('fieldset');
      if (!fieldset) return '';
      var legend = fieldset.querySelector('legend');
      return legend ? (legend.textContent || '').trim() : '';
    }

    document.addEventListener('variant:change', function (e) {
      if (!ampReady()) return;
      var detail = (e && e.detail) || {};
      var variant = detail.variant;
      var prev = detail.previousVariant;
      if (!variant) return;
      var position = getChangedOptionPosition(variant, prev);
      if (position === -1) return;
      var legendText = getLegendForOptionPosition(detail.formId, position);
      if (!legendText || !SIZE_LABEL_RE.test(legendText.toLowerCase())) return;

      var price = centsToPrice(variant.price);
      var props = { try_on_completed: hasCompletedTryOn() };
      if (variant.id != null) props.id = variant.id;
      if (variant.sku != null) props.sku = variant.sku;
      if (price != null) {
        props.price = price;
        var curr = getCurrency();
        if (curr) props.currency = curr;
      }
      if (bodyData.productCategory) props.product_category = bodyData.productCategory;
      if (bodyData.productBrand) props.product_brand = bodyData.productBrand;
      var ssCollections = getProductCollections();
      if (ssCollections) props.product_collections = ssCollections;
      window.amplitude.track('size_selected', props);
    });
  }
})();